export default __webpack_public_path__ + "static/media/logo2.d0472ac9.png";